export const tenantThemeOverrideVariables: readonly string[] = [
  '--theme-primary-50',
  '--theme-primary-100',
  '--theme-primary-200',
  '--theme-primary-300',
  '--theme-primary-400',
  '--theme-primary-500',
  '--theme-primary-600',
  '--theme-primary-700',
  '--theme-primary-800',
  '--theme-primary-900',
  '--theme-surface-page',
  '--theme-surface-muted',
  '--theme-surface-subtle',
  '--theme-surface-toolbar',
  '--theme-surface-control-muted',
  '--theme-neutral-0',
  '--theme-neutral-100',
  '--theme-neutral-200',
  '--theme-neutral-300',
  '--theme-neutral-400',
  '--theme-neutral-500',
  '--theme-neutral-600',
  '--theme-neutral-700',
  '--theme-neutral-800',
  '--theme-neutral-900',
  '--theme-text-primary',
  '--theme-text-secondary',
  '--theme-text-inverse',
  '--theme-text-disabled',
  '--theme-border-strong',
  '--theme-border-subtle',
  '--theme-status-success',
  '--theme-status-warning',
  '--theme-status-danger',
  '--theme-status-info',
  '--theme-status-success-bg',
  '--theme-status-success-text',
  '--theme-status-warning-bg',
  '--theme-status-warning-text',
  '--theme-status-danger-bg',
  '--theme-status-danger-text',
  '--theme-status-info-bg',
  '--theme-status-info-text',
  // do not use following variables for the moment
  /* '--theme-bs-primary',
  '--theme-bs-primary-hover',
  '--theme-bs-primary-active',
  '--theme-bs-link-color',
  '--theme-bs-link-hover-color',
  '--theme-sf-primary',
  '--theme-sf-primary-light',
  '--theme-sf-primary-lighter',
  '--theme-sf-primary-dark',
  '--theme-sf-primary-darker',
  '--theme-sf-primary-hover',
  '--theme-sf-primary-pressed',
  '--theme-sf-primary-focus',
  '--theme-sf-primary-outline',
  '--theme-sf-primary-text',
  '--theme-sf-content-bg',
  '--theme-sf-content-bg-alt1',
  '--theme-sf-content-bg-alt2',
  '--theme-sf-content-bg-hover',
  '--theme-sf-content-bg-pressed',
  '--theme-sf-content-text',
  '--theme-sf-content-text-hover',
  '--theme-sf-content-text-pressed',
  '--theme-sf-placeholder-text',
  '--theme-sf-flyout-bg',
  '--theme-sf-flyout-bg-hover',
  '--theme-sf-flyout-bg-pressed',
  '--theme-sf-flyout-text',
  '--theme-sf-flyout-text-hover',
  '--theme-sf-flyout-text-pressed',
  '--theme-sf-flyout-border' */
] as const;

export const tenantThemeOverrideModes = ['light', 'dark'] as const;

export type TenantThemeOverrideMode = typeof tenantThemeOverrideModes[number];
